import { apiHelper } from "./core";


const getDisabledCenters = (): Promise<any> => {
  return apiHelper
    .get(`${process.env.REACT_APP_BASE_URL}/disabled-centers/`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.error("Error fetching disabled centers:", error);
      return Promise.reject(error)
    })
}

export {
  getDisabledCenters,
}